import './lib/custom-sharrif.min.js';
import search from './search';
import socialSharingHandler from "./socialSharingHandler";
import mobileHandler from "./mobileHandler";

search();
mobileHandler();


document.addEventListener('DOMContentLoaded', () => {
    socialSharingHandler();
});